import { ca } from '@cian/analytics';

export declare type TArchiveReason = 'deal_close' | 'illiquid' | 'temprorily' | 'other_reason';
export declare type TArchiveAction = 'Show' | 'Send';

export function trackOfferMovedToArchive(offerId: number, label: string) {
  ca('event', {
    action: 'archiving',
    category: 'AD_DeleteReason',
    event: 'oldevent',
    label,
    oid: offerId,
  });
}

export function trackArchiveReason(action: TArchiveAction, label?: TArchiveReason) {
  ca('event', {
    action,
    category: 'ArchiveReasonPopup',
    event: 'oldevent',
    ...(label ? {label} : {}),
  });
}
